export default "__VITE_ASSET__Ddmh1aKL__"